/* eslint max-len: [0]*/

import Modernizr from 'modernizr';
import SVGInjector from 'svg-injector';
/*
 * import TweenMax from 'TweenMax';
 * import paper from 'paper';
 */

export default class Background {
	constructor( settings ) {
		const defaults = {
			selector_container: '.c-site-bg',
			selector_svg: '.c-site-bg__svg',
			selector_svg_container: '.c-site-bg__svg-container',
			selector_bg: '.c-site-bg__color',
			selector_noise: '.c-site-bg__noise',
			selector_pattern: '#c-site-bg__svg-pattern',
			selector_rect: '.c-site-bg__svg-rect',
			selector_canvas: 'canvas.c-site-bg__canvas'
		};
		this.options = Object.assign( defaults, settings );
	}

	init () {
		const self = this;

		this.wh = jQuery( document ).height();
		this.ww = jQuery( document ).width();
		
		this.is_loaded = false;
		this.is_visible = false;
    
		this.inject().then( () => {
			// self.initCanvas(); 
		} );
		// this.initParallax();
	}
  
	inject( callback ) {
		const self = this, 
			injectEl = document.querySelector( this.options.selector_svg ),
			promise = jQuery.Deferred(), // eslint-disable-line 
			onFinish = ( totalSVGsInjected ) => {
				document.querySelector( self.options.selector_container ).classList.add( 'is-loaded' );
			
				self.is_loaded = true;
				self.is_visible = true;

				promise.resolve();			
			};

		if ( ! injectEl ) {
			promise.reject();
			
			return promise.promise();
		}

		SVGInjector( injectEl, { // eslint-disable-line
			each( svg ){
				self.svg = svg;
				self.svg_els = svg.querySelectorAll( 'path, polygon, rect, circle' );
				self.svg_pattern = svg.querySelector( 'pattern' );

				gsap.set( self.svg, {
					scale: Modernizr.mq( '(min-width: 992px)' ) ? 2.2 : 4.3,
					transformOrigin: '0 0'
				} );

				gsap.set( self.svg_els, {
					transformOrigin: '50% 50%'
				} );
			}
		}, onFinish );

		return promise.promise();
	}
	
	initParallax(){
		if ( ! jQuery( this.options.selector_container ).hasClass( 'has-parallax' ) ){
			jQuery( this.options.selector_container ).addClass( 'has-parallax' );
			document.addEventListener( 'scroll', jQuery.proxy(this.onScrolling, this), { passive: true } ); // eslint-disable-line
		}
	}

	resetParallax(){
		if ( jQuery( this.options.selector_container ).hasClass( 'has-parallax' ) ){
			jQuery( this.options.selector_container ).removeClass( 'has-parallax' );
			document.removeEventListener( 'scroll', jQuery.proxy(this.onScrolling, this), { passive: true } ); // eslint-disable-line
		}
	}

	onScrolling( event ){
		const self = this,
			scrolled = jQuery( window ).scrollTop();

		jQuery( self.options.selector_svg_container ).css( 'transform', `translateY(${0 - scrolled * .05}px)` );
	}
	
	/*
	 * fadeOut(){
	 * if ( this.is_visible === true ){
	 * gsap.staggerTo( this.svg_pathes, 0.2, {
	 * autoAlpha: 0,
	 * y: 100,
	 * ease: Power2.easeOut
	 * }, 0.01, () => {
	 * this.is_visible = false;
	 * } );
	 * }
	 * }
	 *
	 * fadeIn(){
	 * if ( this.is_visible === false ){
	 * gsap.staggerTo( this.svg_pathes, 0.2, {
	 * autoAlpha: 1,
	 * y: 0,
	 * ease: Power2.easeOut
	 * }, 0.01, () => {
	 * this.is_visible = true;
	 * } );
	 * }
	 * }
	 *
	 * toggleFade(){
	 * if ( this.is_visible ){
	 * this.fadeOut();
	 * } else {
	 * this.fadeIn();
	 * }
	 * }
	 */

	// Canvas Stuff
	/*
	 * addSVGToCanvas( elem ){
	 * const a = paper.project.importSVG( elem );
	 * jQuery( elem ).addClass( 'hidden' );
	 * jQuery( this.options.selector_canvas ).removeClass( 'hidden' );
	 *
	 * return a;
	 * }
	 *
	 * initCanvas(){
	 * const self = this,
	 * $canvas = jQuery( this.options.selector_canvas ),
	 * canvas = $canvas.get( 0 ),
	 * h = jQuery( this.options.selector_container ).height(),
	 * w = jQuery( this.options.selector_container ).width();
	 *
	 * this.setCanvasSize();
	 *
	 * paper.setup( canvas );	
	 *
	 * this.canvasSVG = this.addSVGToCanvas( this.svg );
	 *
	 * this.canvasView = {
	 * height: Number( paper.view.size.height ),
	 * width: paper.view.size.width * 1.2 
	 * };
	 *
	 * this.canvasSVGPathes = [];
	 * paper.project.activeLayer.children[0].children.forEach( ( el, i ) => {
	 * if ( typeof el.segments !== 'undefined' ){
	 * self.canvasSVGPathes.push( el );
	 * }
	 * } );
	 *
	 * paper.project.view.onMouseMove = jQuery.proxy( this.onMouseMoveCanvas, this );
	 * paper.project.view.onFrame = jQuery.proxy( this.onFrameCanvas, this );
	 * }
	 *
	 * setCanvasSize(){
	 * const $canvas = jQuery( this.options.selector_canvas ),
	 * h = jQuery( this.options.selector_container ).height(),
	 * w = jQuery( this.options.selector_container ).width();
	 *
	 * $canvas.height( h ).width( w );
	 * }
	 *
	 * onMouseMoveCanvas( event ){
	 * const self = this;
	 *
	 * self.canvasSVGPathes.forEach( ( el, i ) => {
	 * const location = el.getNearestPoint( event.point ),
	 * path = el,
	 * segment = el.segments;
	 *
	 * if ( location !== null ){
	 * if ( location.y < self.canvasView.height / 4 ) {
	 * // path.position.x = event.point.x; // eslint-disable-line
	 * } else {
	 * // path.opacity = 1;
	 * }
	 * }
	 * } );
	 * }
	 *
	 * onFrameCanvas(){
	 * if ( this.canvasSVGPathes.length ){
	 * this.updateCanvas( this.canvasSVGPathes );
	 * }
	 * }
	 *
	 * updateCanvas( pathes ){
	 * pathes.forEach( ( path, i ) => {
	 * // console.log( el.visible );
	 * } );
	 * }
	 */
}
